import type { MiddlewareFunction } from "@segment/analytics-next";
import { effectiveReferrer, wasChallenged } from "./effectiveReferrer";
import { reportReferrerRestoration } from "./reportReferrerRestoration";

/**
 * Segment source middleware that undoes the referrer a Cloudflare challenge
 * overwrote. Applied to every outgoing event, because Segment attaches
 * `context.page.referrer` to all of them rather than only to pageviews.
 */
export const restoreReferrer: MiddlewareFunction = ({ payload, next }) => {
  const page = payload.obj.context?.page;

  if (page) {
    const documentReferrer = page.referrer ?? "";

    // TEMPORARY (SC-129165): remove alongside reportReferrerRestoration.ts.
    if (wasChallenged(documentReferrer)) {
      reportReferrerRestoration(window.serverReferrer);
    }

    page.referrer = effectiveReferrer({
      documentReferrer,
      serverReferrer: window.serverReferrer,
    });
  }

  next(payload);
};
